import {NgModule} from '@angular/core';
import {MatIconModule} from '@angular/material/icon';
import {CbInfoMessageModule, CbInfoPopupModule, CbLoadingSpinnerModule, CbTableModule} from 'cb-hub-lib';
import {MaintenanceSettingsComponent} from '@app/views/settings/pages/maintenance-settings/maintenance-settings.component';
import {CommonModule} from '@angular/common';
import {MatButtonModule} from '@angular/material/button';
import {MatCardModule} from '@angular/material/card';
import {MatTableModule} from '@angular/material/table';
import {MatTooltipModule} from '@angular/material/tooltip';
import {CbHubTableModule} from '@app/shared/components/table/table.module';

@NgModule({
    declarations: [
        MaintenanceSettingsComponent
    ],
    imports: [
        CommonModule,
        MatCardModule,
        MatIconModule,
        MatButtonModule,
        MatTooltipModule,
        MatTableModule,
        CbInfoMessageModule,
        CbLoadingSpinnerModule,
        CbHubTableModule,
        CbTableModule,
        CbInfoPopupModule
    ],
    exports: [
        MaintenanceSettingsComponent
    ]
})
export class MaintenanceSettingsModule { }
